import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './date.magic.css.js';
import DateComponent from './date.js';

const __vue_script__ = DateComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "magic-ui-form-field",
    {
      staticClass: "date",
      attrs: {
        "no-margin": "",
        part: "date",
        "has-error": _vm.hasDateError,
        message: _vm.errorMessage,
        info: _vm.infoDate,
        "has-info": !!_vm.info
      }
    },
    [
      _c(
        "magic-ui-form-field",
        {
          staticClass: "day",
          attrs: {
            "no-margin": "",
            "no-icon": "",
            part: "day",
            "data-v-test-id": "date-day",
            "has-success":
              !_vm.$v.fullDate.day.$invalid &&
              !_vm.hasError &&
              !_vm.hasAgeError &&
              _vm.hasValue,
            "has-error": _vm.$v.fullDate.day.$error || _vm.hasError
          }
        },
        [
          _c("magic-ui-number", {
            attrs: {
              min: "0",
              max: "31",
              maxlength: "2",
              disabled: _vm.$attrs.disabled,
              focused: _vm.currentField === _vm.DateField.DAY,
              placeholder: _vm.$t("ui-date.day.placeholder"),
              value: _vm.$v.fullDate.day.$model
            },
            on: {
              input: [
                function($event) {
                  return _vm.$set(
                    _vm.$v.fullDate.day,
                    "$model",
                    $event.detail[0]
                  )
                },
                function($event) {
                  return _vm.handleInput("day", _vm.DateField.MONTH, 31)
                }
              ],
              change: function($event) {
                $event.stopPropagation();
              },
              blur: function($event) {
                return _vm.$v.fullDate.day.$touch()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "magic-ui-form-field",
        {
          staticClass: "month",
          attrs: {
            "no-margin": "",
            "no-icon": "",
            part: "month",
            "data-v-test-id": "date-month",
            "has-success":
              !_vm.$v.fullDate.month.$invalid &&
              !_vm.hasError &&
              !_vm.hasAgeError &&
              _vm.hasValue,
            "has-error": _vm.$v.fullDate.month.$error || _vm.hasError
          }
        },
        [
          _c("magic-ui-number", {
            attrs: {
              min: "0",
              max: "12",
              maxlength: "2",
              disabled: _vm.$attrs.disabled,
              focused: _vm.currentField === _vm.DateField.MONTH,
              placeholder: _vm.$t("ui-date.month.placeholder"),
              value: _vm.$v.fullDate.month.$model
            },
            on: {
              input: [
                function($event) {
                  return _vm.$set(
                    _vm.$v.fullDate.month,
                    "$model",
                    $event.detail[0]
                  )
                },
                function($event) {
                  return _vm.handleInput("month", _vm.DateField.YEAR, 12)
                }
              ],
              erase: function($event) {
                return _vm.handleDelete($event, "month", _vm.DateField.DAY)
              },
              change: function($event) {
                $event.stopPropagation();
              },
              blur: function($event) {
                return _vm.$v.fullDate.month.$touch()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "magic-ui-form-field",
        {
          staticClass: "year",
          attrs: {
            "no-margin": "",
            "no-icon": "",
            part: "year",
            "data-v-test-id": "date-year",
            focused: _vm.currentField === _vm.DateField.YEAR,
            "has-success":
              !_vm.$v.fullDate.year.$invalid &&
              !_vm.hasError &&
              !_vm.hasAgeError &&
              _vm.hasValue,
            "has-error": _vm.$v.fullDate.year.$error || _vm.hasError,
            value: _vm.$v.fullDate.year.$model
          },
          on: {
            input: function($event) {
              return _vm.$set(_vm.$v.fullDate.year, "$model", $event.detail[0])
            }
          }
        },
        [
          _c("magic-ui-number", {
            attrs: {
              min: "0",
              max: "2099",
              maxlength: "4",
              disabled: _vm.$attrs.disabled,
              focused: _vm.currentField === _vm.DateField.YEAR,
              placeholder: _vm.$t("ui-date.year.placeholder"),
              value: _vm.$v.fullDate.year.$model
            },
            on: {
              erase: function($event) {
                return _vm.handleDelete($event, "year", _vm.DateField.MONTH)
              },
              change: function($event) {
                $event.stopPropagation();
              },
              blur: function($event) {
                return _vm.$v.fullDate.year.$touch()
              },
              input: function($event) {
                return _vm.$set(
                  _vm.$v.fullDate.year,
                  "$model",
                  $event.detail[0]
                )
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7c12675a_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7c12675a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
